import { ChatGroupId } from '@/chat/models/ChatGroup';
import CleaningStatus from '@/dossier/constants/CleaningStatus';
import { UserId } from '@/shared/models/User';
import AbstractTask from './AbstractTask';
import Tag from '@/shared/models/Tag';

export default class CleaningTask extends AbstractTask {
  assignedUserId: UserId | null = null;
  assignedGroupId: ChatGroupId | null = null;
  exteriorCleaningStatus: CleaningStatus | null = null;
  interiorCleaningStatus: CleaningStatus | null = null;
  isDelivery = true;
  tags: Array<Tag> = [];

  isAssignedToUser(userIds: Array<UserId>): boolean {
    return this.assignedUserId !== null && userIds.includes(this.assignedUserId);
  }

  isAssignedToGroup(groupIds: Array<ChatGroupId>): boolean {
    return this.assignedGroupId !== null && groupIds.includes(this.assignedGroupId);
  }

  updateWith(that: CleaningTask): void {
    this.exteriorCleaningStatus = that.exteriorCleaningStatus;
    this.interiorCleaningStatus = that.interiorCleaningStatus;
    if (this.dossier) {
      this.dossier.pickUpAt = that.dossier?.pickUpAt ?? null;
      this.dossier.waitsOnPremise = that.dossier?.waitsOnPremise ?? false;
    } else {
      this.dossier = that.dossier;
    }
  }
}